import { render, staticRenderFns } from "./AdditionalFieldsEditModal.vue?vue&type=template&id=dbbf36c2&scoped=true&"
import script from "./AdditionalFieldsEditModal.vue?vue&type=script&lang=js&"
export * from "./AdditionalFieldsEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbf36c2",
  null
  
)

export default component.exports